import { render, staticRenderFns } from "./left-nav.vue?vue&type=template&id=01e85c7b&"
import script from "./left-nav.vue?vue&type=script&lang=js&"
export * from "./left-nav.vue?vue&type=script&lang=js&"
import style0 from "./left-nav.vue?vue&type=style&index=0&id=01e85c7b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports